

import React, { useState, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { createCanvas } from 'canvas';

import Accessories from '../components/Accessory';
import Accessories1 from '../components/Accessory1';
import Accessories2 from '../components/Accessory2';
import Accessories3 from '../components/Accessory3';
import Accessories4 from '../components/Accessory4';
import Accessories5 from '../components/Accessory5';
import Accessories6 from '../components/Accessory6';
import Accessories7 from '../components/Accessory7';
import Accessories8 from '../components/Accessory8';
import Accessories9 from '../components/Accessory9';
import Accessories10 from '../components/Accessory10';
import Accessories20 from '../components/Accessory20';
import Accessories21 from '../components/Accessory21';



import './Iris.css';

import bg from '../overlays/bg.png';


 
const canvas = createCanvas(600, 600);
  const ctx = canvas.getContext('2d');
  const back = new Image();
  back.src = bg;
  back.onload = function() {
     ctx.drawImage(back, 0, 0,  600, 600);
   }; 
  // const exportRef = canvas.ref;

const TextInput = ({ label, value, onChange }) => {
  return (
    <div className="text-input">
      <label style={{color: 'white'}}> {label} </label>
      <input type="text" value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
};
/* const handleSave =(canvasref)=>{
    const image = canvasref.toDataURL("image/png", 1.0);
    
const fakeLink = window.document.createElement("a");
fakeLink.style = "display:none;";
fakeLink.download = "meme";

fakeLink.href = image;

document.body.appendChild(fakeLink);
fakeLink.click();
document.body.removeChild(fakeLink);

fakeLink.remove();
}; */


const MemeGenerator = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [topText, setTopText] = useState('');
  const [bottomText, setBottomText] = useState('');
  const exportRef = useRef(null);
  const accRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  



  const ImageUpload = ({onImageUpload}) => {
     const { getRootProps, getInputProps } = useDropzone({
      accept: 'image/*',
      onDrop: (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            
            handleUpload(acceptedFiles[0]);
        }
      },
    });
     return (
      <div className="image-upload-container" {...getRootProps()}>
        <div className="image-cutter">
        
        <div className="image-upload">
        
          <div className="image-upload-border">
            <input {...getInputProps()} />
            <p>Drag & drop or click</p>
            
          </div>
          </div>
        </div>
       
      </div>
    ); 
  }; 

  const handleUpload = (selectedImage) => {
        if (selectedImage) {
          //const canvas = createCanvas(500, 500);
          //const ctx = canvas.getContext('2d');
          const image = new Image();
          image.src = URL.createObjectURL(selectedImage);
          image.onload = () => {
            // Define the maximum width and height for the resized image
            const maxWidth = 500;
            const maxHeight = 500;
    
            // Calculate the new dimensions while maintaining the aspect ratio
            let newWidth = image.width;
            let newHeight = image.height;
            if (newWidth > maxWidth) {
              newWidth = maxWidth;
              newHeight = (image.height * maxWidth) / image.width;
            }
            if (newHeight > maxHeight) {
              newHeight = maxHeight;
              newWidth = (image.width * maxHeight) / image.height;
            }
    
          //  canvas.width = newWidth;
          //  canvas.height = newHeight;
    
            ctx.drawImage(image, 50, 50, 500, 500);  
    
            const memeDataURL2 = canvas.toDataURL('image/png');
            document.getElementById('meme-preview').src = memeDataURL2;
          };
        };
    }; 

   const handleGenerateMeme = () => {
        ctx.fillStyle = 'white';
        ctx.font = '70px Impact';
        ctx.textAlign = 'center';
        ctx.fillText(topText, canvas.width / 2, 70);
        ctx.fillText(bottomText, canvas.width / 2, canvas.height - 20);
        const memeDataURL3 = canvas.toDataURL('image/png');
        document.getElementById('meme-preview').src = memeDataURL3;
    }; 

    const handleSave = () => {
        const canvas1 = exportRef.current;
        const dataUrl = canvas1.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'leet.png';
        link.click();
      };

    const makeInvisible = () => {
        setIsVisible(false);
      }; 
  /*   const toggleVisibility = () => {
        this.setState(prevState => ({
          isVisible: !prevState.isVisible,
        }));
      };  */
     const toggleVisibility = () => {
        setIsVisible(!isVisible)
        }; 

  return (

    <div className="meme-generator" >
        
      <h1 style={{ color: 'white' }}>1337 PFP</h1>
      <ImageUpload onImageUpload={handleUpload} />
      <TextInput label="Top Text" value={topText} onChange={setTopText} />
      <TextInput label="Bottom Text" value={bottomText} onChange={setBottomText} />
      {/* <button onClick={handleUpload}>Upload</button> */}
       
      {/* <button onClick={handleSave}> Save </button> */}
      {/* <button onClick={toggleVisibility(setIsVisible)}> toggle </button>   */}
      <button onClick={toggleVisibility}>CLICK TO HIDE CONTROLS!!!</button> <a>   </a><button onClick={handleGenerateMeme}>Add Text</button> 
      <div className="export">
        
       <div className="meme-preview" >
         <img id="meme-preview"  style={{ width: 600, height: 600 } } /> 
        </div>  
         {/* <div className="canvas"><img src={canvas.toDataURL()} alt="Canvas" /></div>   */}
       
    <Accessories isVisible={isVisible}  />
    <Accessories isVisible={isVisible}  />
    <Accessories isVisible={isVisible}  />
    <Accessories isVisible={isVisible}  />
    <Accessories isVisible={isVisible}  />
    <Accessories1 isVisible={isVisible} ref={accRef}/><Accessories1 isVisible={isVisible} ref={accRef}/><Accessories1 isVisible={isVisible} ref={accRef}/><Accessories1 isVisible={isVisible} ref={accRef}/><Accessories1 isVisible={isVisible} ref={accRef}/><Accessories1 isVisible={isVisible} ref={accRef}/>
      <Accessories2  isVisible={isVisible}/><Accessories2  isVisible={isVisible}/><Accessories2  isVisible={isVisible}/><Accessories2  isVisible={isVisible}/><Accessories2  isVisible={isVisible}/><Accessories2  isVisible={isVisible}/><Accessories2  isVisible={isVisible}/><Accessories2  isVisible={isVisible}/>
      <Accessories3 isVisible={isVisible} /><Accessories3 isVisible={isVisible} /><Accessories3 isVisible={isVisible} /><Accessories3 isVisible={isVisible} /><Accessories3 isVisible={isVisible} /><Accessories3 isVisible={isVisible} /><Accessories3 isVisible={isVisible} /><Accessories3 isVisible={isVisible} /><Accessories3 isVisible={isVisible} />
      <Accessories4 isVisible={isVisible}/><Accessories4 isVisible={isVisible}/><Accessories4 isVisible={isVisible}/><Accessories4 isVisible={isVisible}/><Accessories4 isVisible={isVisible}/><Accessories4 isVisible={isVisible}/><Accessories4 isVisible={isVisible}/><Accessories4 isVisible={isVisible}/>
      <Accessories5 isVisible={isVisible} /><Accessories5 isVisible={isVisible} /><Accessories5 isVisible={isVisible} /><Accessories5 isVisible={isVisible} /><Accessories5 isVisible={isVisible} /><Accessories5 isVisible={isVisible} /><Accessories5 isVisible={isVisible} /><Accessories5 isVisible={isVisible} /><Accessories5 isVisible={isVisible} />
      <Accessories6 isVisible={isVisible} /><Accessories6 isVisible={isVisible} /><Accessories6 isVisible={isVisible} /><Accessories6 isVisible={isVisible} /><Accessories6 isVisible={isVisible} /><Accessories6 isVisible={isVisible} /><Accessories6 isVisible={isVisible} /><Accessories6 isVisible={isVisible} /><Accessories6 isVisible={isVisible} />
      {/* <Accessories6 image={selectedImage} accessories={[sticker6]} /> */}
      <Accessories7 isVisible={isVisible}  />
      <Accessories8 isVisible={isVisible}  />
      <Accessories9 isVisible={isVisible}  />
      <Accessories10 isVisible={isVisible}  />
      <Accessories20 isVisible={isVisible}  />
      <Accessories21 isVisible={isVisible}  />
      
      </div>

      <div><canvas ref={exportRef}/></div>



    </div> 

  );

};
    

export default MemeGenerator;
